// extracted by mini-css-extract-plugin
module.exports = {"removeCardsBtn":"ProductListRemoveButton_removeCardsBtn__lctpf","removeCardsBtnActive":"ProductListRemoveButton_removeCardsBtnActive__2YUHa"};